import base from "/app/images/genius-active.svg?svg";
import { getResizer } from "svg-merge-attributes";
export default getResizer(base, "");